import servicesData from "../data/servicesData";
import ServiceCard from "./ServiceCard";

export default function Services() {
  return (
    <section className="services">
      <div className="container">
        <div className="services-grid">
          {servicesData.map(s => <ServiceCard key={s.id} {...s} />)}
        </div>
      </div>
    </section>
  );
}